<main class="page-container">
  <div class="float-card-container">
    <app-float-card></app-float-card>
  </div>
</main>
